import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';

export type qbTransactionOptions = {
  searchQuery: string;
};
export const getTransactions = ({ searchQuery }: qbTransactionOptions): Promise<any> => {
  return axios.get(`/qb/transactions${searchQuery}`);
};

type UseTransactionOptions = {
  config?: MutationConfig<typeof getTransactions>;
};

export const useQBTransactions = ({ config }: UseTransactionOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getTransactions,
  });
};

export type qbAnalyticsOption = {
  searchQuery: string;
};
export const getQBAnalytics = ({ searchQuery }: qbAnalyticsOption): Promise<any> => {
  return axios.get(`/qb/analytics${searchQuery}`);
};

type UseAnalyticOptions = {
  config?: MutationConfig<typeof getTransactions>;
};

export const useQBAnalytics = ({ config }: UseAnalyticOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getQBAnalytics,
  });
};

export const getCompanyInfo = (): Promise<any> => {
  return axios.get(`/qb/getCompanyInfo`);
};

export const useQBCompanyInfo = ({ config }: UseTransactionOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Retrieved company data successfully',
      });
    },
    ...config,
    mutationFn: getCompanyInfo,
  });
};
export type qbCallbackOptions = {
  searchQuery: string;
};

export const qbCallback = ({ searchQuery }: qbCallbackOptions): Promise<any> => {
  return axios.get(`/qb/callback${searchQuery}`);
};

export const useQBCallback = ({ config }: UseTransactionOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: qbCallback,
  });
};
